"use client"

import { ExtrapolatedGraphRenderer } from './ExtrapolatedGraphRenderer'
import { useExtrapolatedGraphRenderProps } from './useExtrapolatedGraphRenderProps'
import type { ExtrapolatedGraphProps } from './types'

export const ExtrapolatedGraph = (props: ExtrapolatedGraphProps) => {
  const renderProps = useExtrapolatedGraphRenderProps(props)

  return <ExtrapolatedGraphRenderer {...renderProps} />
}
